import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { FormControl, MenuItem, Select, Typography } from '@mui/material';
import _ from 'lodash';
import { useAuthAxios } from '../../hooks/useAuthAxios';
import {
  InspectionStatusList,
  InspectionStatusListLabel,
  SubCategoryTypeList,
  SubCategoryTypeListLabel,
  UserRoleList,
  UserRoleListLabel,
} from '../../utils/enum';
import { SelectHelperText } from '../style/TextStyle';

const Placeholder = ({ children }: any) => {
  return <Typography sx={{ color: '#79767D' }}>{children}</Typography>;
};

export function TypeSelect({ type, onChange, helperText = '' }: any) {
  const [getCategoriesResult] = useAuthAxios(
    {
      method: 'GET',
      url: '/api/v1/category',
    },
    { manual: false },
  );
  const categories = _.get(getCategoriesResult, 'response.data');
  const categoryTable = _.keyBy(categories, 'categoryId');

  return (
    <FormControl
      style={{
        background: '#FFFFFF',
        flex: 1,
      }}
    >
      <Select
        size="small"
        value={type}
        onChange={onChange}
        displayEmpty
        IconComponent={KeyboardArrowDownIcon}
        renderValue={selected => {
          if (selected?.length === 0 || selected === undefined) {
            return <Placeholder>구분</Placeholder>;
          }
          return _.get(categoryTable, selected, { title: '' }).title;
        }}
      >
        <MenuItem value="">선택없음</MenuItem>
        {_.map(categories, type => (
          <MenuItem key={type?.categoryId} value={type?.categoryId}>
            {type?.title || '-'}
          </MenuItem>
        ))}
      </Select>
      <SelectHelperText>{helperText}</SelectHelperText>
    </FormControl>
  );
}

export function DepartmentSelect({
  department,
  onChange,
  helperText = '',
}: any) {
  const [getDepartmentsResult] = useAuthAxios(
    {
      method: 'GET',
      url: `/api/v1/department`,
    },
    { manual: false },
  );
  const departments = _.get(getDepartmentsResult, 'response.data.result');
  const departmentTable = _.keyBy(departments, 'departmentId');

  const selectedDepartment = department || '';

  return (
    <FormControl
      style={{
        background: '#FFFFFF',
        flex: 1,
      }}
    >
      <Select
        size="small"
        value={selectedDepartment}
        onChange={onChange}
        IconComponent={KeyboardArrowDownIcon}
        displayEmpty
        renderValue={selected => {
          if (selected === '') {
            return <Placeholder>부서</Placeholder>;
          }
          return _.get(departmentTable, selected, { title: '' }).title;
        }}
      >
        <MenuItem value="">선택없음</MenuItem>
        {_.map(departments, depart => (
          <MenuItem key={depart.departmentId} value={depart.departmentId}>
            {depart?.title || '-'}
          </MenuItem>
        ))}
      </Select>
      <SelectHelperText>{helperText}</SelectHelperText>
    </FormControl>
  );
}

export function FacilitySelect({
  value,
  onChange,
  formControlProps = {},
  helperText = '',
}: any) {
  const selectedValue = value === undefined ? '' : value;
  return (
    <FormControl
      style={{
        background: '#FFFFFF',
        flex: 1,
        display: 'flex',
      }}
      {...formControlProps}
    >
      <Select
        size="small"
        value={selectedValue}
        onChange={onChange}
        IconComponent={KeyboardArrowDownIcon}
        displayEmpty
        renderValue={selected => {
          if (selected === '') {
            return <Placeholder>야외운동기구</Placeholder>;
          }
          return SubCategoryTypeListLabel[selected];
        }}
      >
        <MenuItem value="">선택없음</MenuItem>
        {[SubCategoryTypeList.SINGULAR, SubCategoryTypeList.COMPOSITE].map(
          type => (
            <MenuItem key={type} value={type}>
              {SubCategoryTypeListLabel[type]}
            </MenuItem>
          ),
        )}
      </Select>
      <SelectHelperText>{helperText}</SelectHelperText>
    </FormControl>
  );
}

export function UserRoleSelect({ role, onChange }: any) {
  return (
    <FormControl
      style={{
        background: '#FFFFFF',
        flex: 1,
      }}
    >
      <Select
        size="small"
        value={role}
        onChange={onChange}
        IconComponent={KeyboardArrowDownIcon}
        displayEmpty
        renderValue={(selected: UserRoleList) => {
          if (selected?.length === 0 || selected === undefined) {
            return <Placeholder>권한</Placeholder>;
          }
          return UserRoleListLabel[selected];
        }}
      >
        <MenuItem value="">선택없음</MenuItem>
        {[UserRoleList.MANAGER, UserRoleList.USER].map(role => (
          <MenuItem key={role} value={role}>
            {UserRoleListLabel[role]}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export function StatusSelect({ status, onChange }: any) {
  return (
    <FormControl
      style={{
        background: '#FFFFFF',
        flex: 1,
      }}
    >
      <Select
        size="small"
        value={status}
        onChange={onChange}
        IconComponent={KeyboardArrowDownIcon}
        displayEmpty
        renderValue={(selected: InspectionStatusList) => {
          if (selected?.length === 0 || selected === undefined) {
            return <Placeholder>점검여부</Placeholder>;
          }
          return InspectionStatusListLabel[selected];
        }}
      >
        <MenuItem value="">선택없음</MenuItem>
        {[
          InspectionStatusList.INSPECTION_NEED,
          InspectionStatusList.INSPECTED,
          InspectionStatusList.INSPECTION_NOT_REQUIRED,
        ].map(status => (
          <MenuItem key={status} value={status}>
            {InspectionStatusListLabel[status]}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export function DepartmentSelectByTitle({
  department,
  onChange,
  helperText = '',
}: any) {
  const [getDepartmentsResult] = useAuthAxios(
    {
      method: 'GET',
      url: `/api/v1/department`,
    },
    { manual: false },
  );
  const departments = _.get(getDepartmentsResult, 'response.data.result');

  return (
    <FormControl
      style={{
        background: '#FFFFFF',
        flex: 1,
      }}
    >
      <Select
        size="small"
        value={department}
        onChange={onChange}
        IconComponent={KeyboardArrowDownIcon}
        displayEmpty
        renderValue={selected => {
          if (selected?.length === 0 || selected === undefined) {
            return <Placeholder>부서</Placeholder>;
          }
          return selected;
        }}
      >
        <MenuItem value={undefined}>선택없음</MenuItem>
        {_.map(departments, depart => (
          <MenuItem key={depart.departmentId} value={depart.title}>
            {depart?.title || '-'}
          </MenuItem>
        ))}
      </Select>
      <SelectHelperText>{helperText}</SelectHelperText>
    </FormControl>
  );
}
